import React, { Component } from "react";
import { ListingContext } from "../../Context";
import _ from "lodash";

import { PrimaryColor } from "../../utils/consts";

import SkeletonText from "../../components/skeleton/SkeletonText";

import CheckIcon from "@atlaskit/icon/glyph/check";

export default class ListingAmenities extends Component {
  render() {
    return (
      <ListingContext.Consumer>
        {listingContext => {
          const listing = listingContext.listing || {};
          const amenities = listing.amenities || {};
          if (listingContext.loading) {
            return (
              <div className="listing-amenities">
                <SkeletonText lines={4} />
              </div>
            );
          } else if (!_.isEmpty(amenities)) {
            return (
              <div className="listing-amenities">
                <h5 className="listing-section__title">Amenities</h5>
                <div className="listing-amenities__amenities">
                  {Object.keys(amenities)
                    .sort()
                    .map(item => (
                      <span
                        key={`listing-list__item_${item}`}
                        className="listing-list__item"
                      >
                        <span className="listing-item__icon">
                          <CheckIcon
                            small="small"
                            primaryColor={PrimaryColor}
                          />
                        </span>
                        {item.replace(/_/g, " ")}
                      </span>
                    ))}
                </div>
              </div>
            );
          } else {
            return null;
          }
        }}
      </ListingContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/listing/ListingAmenities.js